import React from 'react';
import { toast } from 'react-toastify';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Prevent React red screen
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.warn('Caught by ErrorBoundary:', error);

    if (error?.name === 'NotAllowedError' || error?.message?.includes('user agent')) {
      toast.error('Permission error: Please allow microphone or camera.');
    } else {
      toast.error('An unexpected error occurred.');
    }
  }

  render() {
    if (this.state.hasError) {
      // Show fallback UI instead of red screen
      return (
        <div style={{ color: '#fff', textAlign: 'center', padding: '2rem' }}>
          <h2>⚠️ Something went wrong</h2>
          <p>Please refresh the page or check media permissions.</p>
        </div>
      );
    }

    return this.props.children;
  }
}
